import React from 'react';
import { Upload, Download } from 'lucide-react';
import type { ResumeData } from '../types';

interface ResumeImportExportProps {
  onImport: (data: ResumeData) => void;
  data: ResumeData | null;
}

export function ResumeImportExport({ onImport, data }: ResumeImportExportProps) {
  const handleImport = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const importedData = JSON.parse(e.target?.result as string);
          onImport(importedData);
        } catch (error) {
          console.error('Invalid file format');
        }
      };
      reader.readAsText(file);
    }
  };

  const handleExport = () => {
    if (!data) return;
    
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'resume-data.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="flex gap-4">
      <label className="cursor-pointer bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 
        py-2 rounded-lg transition-colors flex items-center gap-2">
        <Upload className="w-4 h-4" />
        <span>Import</span>
        <input
          type="file"
          accept=".json"
          onChange={handleImport}
          className="hidden"
        />
      </label>
      
      <button
        onClick={handleExport}
        disabled={!data}
        className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg 
          transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Download className="w-4 h-4" />
        Export
      </button>
    </div>
  );
}